module.exports = __webpack_public_path__ + "static/media/photoconLogo.cf653303.png";